var t={name:"rzIconBigPlus",props:{width:{type:Number,default:19},height:{type:Number,default:20}},computed:{viewBox:function(){return"0 0 ".concat(this.width," ").concat(this.height)}}};export{t as default};
